<template lang="pug">
  .component-packet-vehicle-category-buttons
    packet-vehicle-category-modal(:packetCategory="item", @itemUpdated="$emit('itemUpdated')")
      .dropdown-buttons
        button.button Edit
    .dropdown-buttons
      ActionButton(:action="remove", :confirm="true") Delete

</template>

<script>
import PacketVehicleCategoryModal from "./reveal/PacketVehicleCategoryModal";
import KeplerBackofficeSdk from "../../../../lib/kepler/backoffice";
import MaggieHelper from "../../../../maggieHelper";
import ActionButton from "../ActionButton";

export default {
  name: "PacketVehicleCategoryButton",
  components: {PacketVehicleCategoryModal,ActionButton},
  data() {
    return {
    }
  },
  created() {
  },
  methods: {
    remove: function () {
      return KeplerBackofficeSdk.packetVehicleCategories.select(this.item).delete(this.item,(data) => {
        MaggieHelper.notification('delete-esit', data.result_code)
        this.$emit('itemUpdated')
      })
    },
  },

  props: ['item']
}

</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// PacketVehicleCategoryButton.vue?7ead1812